{
  "title": "உள்பெட்டி",
  "totalBadge": "{{count}} உருப்படிகள்",
  "viewAll": "அனைத்தையும் காண்க",
  "loading": "ஏற்றுகிறது…",
  "emptySection": "அனைத்தும் முடிந்தது",
  "loadError": "இந்தப் பகுதியை ஏற்ற முடியவில்லை"
}
